import React, { useEffect, useMemo, useState } from 'react';

import { useAccount } from 'wagmi';
import toast from '../libs/toast';
import { defaultProvider, getBuyTokenContract } from '../helpers/web3utils';
import { ethers } from 'ethers';
import ListRef from './ListRef';
import {
  useCanClaimPercent,
  useClaimCommissionToken,
  useTotalBuy,
  useTotalClaimRef,
  useTotalCommission
} from '../hooks/useContract';
import clsx from 'clsx';

const Loyalti = () => {
  const { address, isConnected } = useAccount();

  const { data: dataCanClaimPercent } = useCanClaimPercent();
  const { data: dataTotalBuy, refetch } = useTotalCommission(address);

  const { data: dataTotalClaim, refetch: refetch2 } = useTotalClaimRef(address);
  const canClaim = useMemo(() => {
    return Number(
      ethers.formatEther(
        (BigInt(dataTotalBuy || 0) * BigInt(dataCanClaimPercent || 0)) / BigInt(100) -
          BigInt(dataTotalClaim || 0)
      )
    );
  }, [dataCanClaimPercent, dataTotalClaim, dataTotalBuy]);
  const [refCode, setRefCode] = useState();
  const [totalCommissioAIW, setTotalCommissionAIW] = useState(0);
  const [totalCommissionBNB, setTotalCommissionBNB] = useState(0);
  const [totalClaimed, setTotalClaimed] = useState(0);
  const { isPending, handleClaim } = useClaimCommissionToken(() => {
    refetch2();
    refetch();
  });
  const [refList, setRefList] = useState({
    total: 0,
    directly: [],
    indirectly: []
  });

  useEffect(() => {
    if (isConnected) {
      loadData();
    }
  }, [isConnected]);
  const copyText = async (text) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported');
      document.execCommand('copy', true, text);
      toast.success('Copied');
      return true;
    }
    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);

      toast.success('Copied');

      return true;
    } catch (error) {
      console.warn('Copy failed', error);
      // toast.error("Trình duyệt không hỗ trợ");
      document.execCommand('copy', true, text);
      toast.success('Copied');
      return true;
    }
  };
  const loadData = async () => {
    var contract = getBuyTokenContract();

    contract = contract.connect(defaultProvider());

    if (address && address != ethers.ZeroAddress) {
      console.log(address);
      contract.totalCommission(address).then((commission) => {
        setTotalCommissionAIW(ethers.formatEther(commission));
      });

      contract.totalBuyBNB(address).then((totalBuy) => {
        console.log(Number(ethers.formatEther(totalBuy)));
        if (Number(ethers.formatEther(totalBuy)) >= 0.1) {
          setRefCode(process.env.REACT_APP_WEB_HOST + '/ref/' + address);
        } else {
          setRefCode('Purchase a minimum of 0.1 BNB to unlock the referral feature.');
        }
      });
      contract.totalCommissionBnb(address).then((commission) => {
        setTotalCommissionBNB(Number(ethers.formatEther(commission)));
      });
      contract.totalClaimRef(address).then((claimedAmount) => {
        setTotalClaimed(Number(ethers.formatEther(claimedAmount)));
      });
      const getRefList = async (address, level = 1, maxLevel = 2) => {
        if (level === maxLevel) {
          return {
            total: 0,
            data: []
          };
        }
        let data = [];
        const info = await contract.getAllF1(address);
        for (const adr of info._all) {
          let totalBuy = await contract.totalBuyBNB(adr);
          totalBuy = Number(ethers.formatEther(totalBuy));
          data.push({
            address: adr,
            amount: totalBuy
          });
          const item = await getRefList(adr, level + 1, maxLevel);
          if (item.data?.length) {
            data = data.concat(item.data);
          }
        }

        return {
          total: info._total,
          data
        };
      };
      const f1 = await getRefList(address);
      let otherF = [];
      for (const f of f1.data) {
        const d = await getRefList(f.address, 1, 5);
        otherF = otherF.concat(d.data);
      }
      setRefList({
        total: f1.total,
        directly: f1.data,
        indirectly: otherF
      });
    } else {
      setTotalClaimed(0);
      setTotalCommissionAIW(0);
      setTotalCommissionBNB(0);
      setRefList({
        total: 0,
        directly: [],
        indirectly: []
      });
    }
  };

  return (
    <>
      <div className="tab-box" data-id="loyalty">
        <p className="p-presale-body__ttl">REFERRALS</p>
        <div className="p-presale-row --center">
          <div className="p-presale-row__item --fill">
            <p className="p-presale-body__txt">
              Share your referral code and get rewards from your invitees (up to 6% from each
              purchase)
            </p>
          </div>
          {/* <div className="p-presale-row__item --shrink --right">
            <p className="p-presale-row__ttl">0 invitess</p>
          </div> */}
        </div>
        <div className="p-presale-copy">
          <input
            className="p-presale-copy__txt"
            type="text"
            defaultValue=""
            value={refCode}
            onChange={(e) => setRefCode(e.target.value)}
          />
          {refCode?.startsWith(process.env.REACT_APP_WEB_HOST) ? (
            <span className="p-presale-copy__btn" onClick={() => copyText(refCode)}>
              Copy
            </span>
          ) : (
            <></>
          )}
        </div>
        <div className="p-presale-area">
          <div className="p-presale-area__item" style={{ marginBottom: 0 }}>
            <p className="p-presale-area__sub --upper">Can claim</p>
            <p className="p-presale-area__balance">Total bonus: {totalCommissioAIW} AIW</p>
          </div>
          <input
            type="number"
            className=" p-presale-copy__txt"
            onChange={() => {}}
            value={canClaim}
            disabled
            style={{ border: 'none', fontSize: 16, fontStyle: 'none' }}
          />
          {canClaim > 0 ? (
            <div className="p-presale-body__bottom">
              <div className="p-presale-body__bottom-wrap">
                <button
                  disabled={isPending}
                  className={clsx('p-presale-area__btn p-presale-btn', isPending ? 'disable' : '')}
                  onClick={handleClaim}
                >
                  Claim AIW
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="p-presale-realy">
          <div className="p-presale-realy__item">
            <p className="p-presale-realy__txt">Already Received</p>
            <p className="p-presale-realy__number">{totalCommissionBNB.toFixed(6)} BNB</p>
          </div>
          <div className="p-presale-realy__item" style={{ height: '100%' }}>
            <p className="p-presale-realy__txt">Already Claimed</p>
            <p className="p-presale-realy__number">{totalClaimed} AIW</p>
          </div>
          {/* <div className="p-presale-realy__item">
            <p className="p-presale-realy__txt">Total</p>
            <p className="p-presale-realy__number">0 USDT</p>
          </div> */}
          <div className="p-presale-realy__item" style={{ height: '100%' }}>
            <ListRef refList={refList} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Loyalti;
